const ArrowLeftIcon = (props) => (
    <svg width={32} height={32} fill="none" {...props}>
        <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M27 16H5m0 0 9-9m-9 9 9 9" />
    </svg>
);

export default ArrowLeftIcon;
